const $ = require('jquery');

const autoFill = function () {
	// Webkit autocompletes but doesn't actually change the val. So whe check for :-webkit-autofill via css animation-name.
	$(window).on('load', () => {
		// console.log('loaded');
        if ($('.input, .textarea').css('animation-name') == 'cancelAutofill') {
            $(this).closest('.js-float-label').addClass('is-active');
        }
    });
};

module.exports = autoFill;
